/**
 * LEGACY!
 * It has been created before LaunchDarkly was introduced.
 *
 * @type {{CUSTOM_DOCUMENTS: boolean}}
 */
export const isFeatureEnabled = {
  CUSTOM_DOCUMENTS: true,
};
